import React, { Component } from 'react'
import {  Col, FormGroup ,Label, Badge } from "react-bootstrap";
import {  Field, reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import moment from 'moment'
import { saveLaneConditionsInfo } from "../../../../redux/actions/action_event"
import {  videoblue, gray,forms, lblattrs, inputattrs } from "../../../../utils/constants"
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent'
import OilRatio from '../OilRatio'
import EventDetailsFields  from '../EventDetails/fields'
import fields from './fields'

const FormName = forms.eventinfo

class LaneConditions extends Component {

    static propTypes = {
        ...propTypes
    }
    constructor(props){
			super(props)
			this.handleEventDurationChange    = this.handleEventDurationChange.bind(this)
			this.handleOilRatioChangeByGender = this.handleOilRatioChangeByGender.bind(this)
			this.displayRatios   = this.displayRatios.bind(this)
			this.getmaxeventdays = this.getmaxeventdays.bind(this)
			this.getOilRatios    =  this.getOilRatios.bind(this)
    }
    componentDidMount(){
			window.scrollTo(0, 0)
		}
    componentWillUnmount()
    {    
			const { dispatch,eventId, oilratio, dailyoilratios,dailyoilratioswomen,dailyoilratiosmen } = this.props
			const oilRatio = this.getOilRatios(oilratio, dailyoilratios,dailyoilratiosmen,dailyoilratioswomen) 
			const laneConditions = {
				oilRatio:oilRatio
			}      
			const details = {
				laneConditions:laneConditions,
				eventId: eventId,
				step:3
			}
			console.log('Saving oil conditions details',details)
			dispatch(saveLaneConditionsInfo(details))
    }
    getOilRatios(eventOilRatios, dailyOilRatios,dailyOilRatiosMen,dailyOilRatiosWomen){
			let oilRatio = []
			let menratio
			let womenratio
			const day1 = eventOilRatios[1]
			const day2 = eventOilRatios[2]
			const day3 = eventOilRatios[3]
    //  console.log('getOilRatios eventOilRatios,dailyOilRatios,day1,day2,day3', eventOilRatios,dailyOilRatios,day1,day2,day3)
		//	if ((dailyOilRatios == 'false')) 
	
			if (	day1 != undefined	) {
				//let menratio
				//let womenratio
				if((dailyOilRatios == 'false'))	{
					menratio = day1.single,
					womenratio = day1.single
				}
				else {
					menratio = day1.men != "" ? day1.men:day1.single,
					womenratio = day1.women != "" ? day1.women:day1.single
				}
				oilRatio.push({
					day:1,
					men:menratio,
					women:womenratio
				})
			}
			if	(	dailyOilRatios == 'true'	)	{
				if	(	day2 != undefined	) {
					oilRatio.push({
						day:2,
						men:day2.men != "" ? day2.men:day2.single,
						women:day2.women != "" ? day2.women:day2.single
					})
				}
				if	(	day3 != undefined	)	{
					oilRatio.push({
						day:3,
						men:day3.men != "" ? day3.men:day3.single,
						women:day3.women != "" ? day3.women:day3.single
					})
				}
			}
			else {
				oilRatio   = []
				menratio   = day1.single
				womenratio = day1.single
				oilRatio.push({
					day:1,
					men:menratio,
					women:womenratio
				})
			}
			// check is there is already an entry in array for day 2
			let arrayDay2 = _.find(oilRatio,{ 'day':2 })
			let arrayDay3 = _.find(oilRatio,{ 'day':3 })
			if	(	dailyOilRatiosMen == 'true'	)	{
				if((day2 != undefined) && (day2.men != "")) {
					if(arrayDay2 != null){
						arrayDay2.men=day2.men
					}
					else {
						arrayDay2 = {
							day:2,
							men:day2.men
						}
						oilRatio.push(arrayDay2)
					}
				}
				if((day3 != undefined) && (day3.men != "")){
					if(arrayDay3 != null){
						arrayDay3.men=day3.men
					}
					else {
						arrayDay3 = {
								day:3,
								men:day3.men
						}
						oilRatio.push(arrayDay3)
					}
				}
			}	
			if(dailyOilRatiosWomen == 'true'){

				if((day2 != undefined) && (day2.women != "")) {
					if(arrayDay2 != null){
						arrayDay2.women=day2.women
					}
					else {
						oilRatio.push({
							day:2,
							women:day2.women
						})
					}
				}
				if((day3 != undefined) && (day3.women != "")){
					if(arrayDay3 != null){
						arrayDay3.women=day3.women
					}
					else {
						oilRatio.push({
							day:3,
							women:day3.women
						})
					}
				}
			}
			return oilRatio
     }
    handleEventDurationChange(event)
    {
        const target = event.target;
        const value = target.value;
        this.props.dispatch(change(FormName, fields.EVENTNUMBEROFDAYS,value))
    }
    handleOilRatioChangeByGender(event)
    {
			const target = event.target;
			const value = target.value;
			const { dispatch } = this.props
			if	(value == 'false')
			{
				dispatch(change(FormName, 'oilratio.1.men',''))
				dispatch(change(FormName, 'oilratio.2.men',''))
				dispatch(change(FormName, 'oilratio.3.men',''))
				dispatch(change(FormName, 'oilratio.1.women',''))
				dispatch(change(FormName, 'oilratio.2.women',''))
				dispatch(change(FormName, 'oilratio.3.women',''))
			}
    }
    displayRatios() {
			if (this.props.isoilratiobygender == 'true') 
				return (
				<div>
					<FormGroup>
						<OilRatio gender='Men'/>
					</FormGroup>
					<FormGroup>
						<OilRatio  gender='Women'/>
					</FormGroup>
				</div>)
			else
				return(
					<FormGroup style={{ marginLeft:'-5px' }}>
						<OilRatio/>
					</FormGroup>
				)  
    }     
    getmaxeventdays(maxeventduration)
    {
			const days = _.range(0,maxeventduration)
			const eventdays = _.map(days, function(item) {
				const day = (item + 1).toString()
				return {
					name:day,
					abbreviation:day
				}
			})
			return eventdays
    }
    render(){
        
			const {  startdate,enddate,isoilratiobygender,eventgendermen,eventgenderwomen,eventname,handleSubmit, previousPage } = this.props   
			const dates = startdate != enddate ?  `( ${moment(startdate).format('ddd, ll')} to ${moment(enddate).format('ddd, ll')})` : `(${moment(startdate).format('ddd, ll')} ${' '} )`
			const numberOfDays = (moment(enddate).diff(moment(startdate),'days') + 1 ).toString()
			const imageIcon = "fa fa-caret-right"
			return (
				<div style={{ marginTop:'0%' }} sm={12} md={12} lg={12}>
					<form id='eventinfo' onSubmit={handleSubmit} className="form-horizontal" sm={12} md={12} lg={12} >
						<Col lg={12} md={12} style={{ border:`1px solid ${gray}`, padding:'15px' , marginRight:'0px', marginBottom:'15px' }}> 
							<FormGroup style={{ paddingLeft:'15px', paddingBottom:'0', marginBottom:'0' }}>
								<h4 className='col-sm-12 col-md-12 col-lg-7' style={{ color:videoblue }}>{' '}Lane Conditions - <span style={{ color:'green' }}>{_.startCase(_.toLower(eventname))}</span></h4>              
							</FormGroup>
							<FormGroup>
								<label className={lblattrs}>Event number of days</label>
								<Col sm={1} md={1} lg={1}>                               
									<Label className="form-control" style={{ padding:'10px' }}><Badge  style={{ color:'black', fontSize:'130%', padding:'10px' }}>{numberOfDays} {'  '} {dates}</Badge></Label>
								</Col>
							</FormGroup>
						{ eventgendermen && eventgenderwomen &&  <Field
								label='Do oil ratios vary based on gender?'
								labelattrs = {lblattrs}
								inputattrs = {inputattrs}
								name={fields.ISOILRATIOBYGENDER}
								id={fields.ISOILRATIOBYGENDER}
								values={[
								{ name:'Yes', abbreviation:'true' },
								{ name:'No', abbreviation:'false' },
								
								]}
								component={renderOptionsField}
								defaultvalue={isoilratiobygender}
								onChange={this.handleOilRatioChangeByGender}
							/> 
						}
						{	this.displayRatios()	}            
						</Col>
						<Col sm={12} >
							<button type="button" className="btn btn-primary pull-left previous" onClick={previousPage} style={{ minWidth:'120px', fontSize:'120%',fontWeight:'bold'  }}>
								<i className="fa fa-caret-left" aria-hidden="true"  />&nbsp;&nbsp;Previous
							</button>
							<button type="submit" className="btn btn-primary pull-right next" style={{ minWidth:'120px', fontSize:'120%',fontWeight:'bold'  }}>
								<i className={imageIcon} aria-hidden="true" />&nbsp;&nbsp; Next
							</button>              
						</Col> 
					</form>
				</div>)
			}
    }
    function mapStateToProps(state,ownProps){ 
			const formName =  ownProps.form
			const selector = formValueSelector(formName)
			const eventnumberofdays   = selector(state,fields.EVENTNUMBEROFDAYS)
			const isoilratiobygender  = selector(state,fields.ISOILRATIOBYGENDER)
			const dailyoilratios      = selector(state,fields.DAILYOILRATIOS)
			const dailyoilratiosmen   = selector(state,fields.DAILYOILRATIOSMEN)
			const dailyoilratioswomen = selector(state,fields.DAILYOILRATIOSWOMEN)
			const oilratio = selector(state,fields.OILRATIO)
			const eventgendermen   = selector(state,EventDetailsFields.GENDERMEN)
			const eventgenderwomen = selector(state,EventDetailsFields.GENDERWOMEN)
			const maxeventduration = selector(state,'maxeventduration')
			const startdate = selector(state,'startdate')
			const enddate   = selector(state,'enddate')
			const eventId   = selector(state,'eventId')
			const eventname = selector(state,'eventname')
			return {
				eventname,
				eventnumberofdays,
				isoilratiobygender,
				dailyoilratios,
				oilratio,
				eventgendermen,
				eventgenderwomen,
				maxeventduration,
				startdate,
				enddate,
				eventId,
				dailyoilratiosmen,
				dailyoilratioswomen				
			}
    }  
    function mapDispatchToProps(dispatch){
			return bindActionCreators({
				saveLaneConditionsInfo
			},dispatch)
    }
    LaneConditions.propTypes = {
			handleSubmit: PropTypes.func,
			previousPage:PropTypes.func,
			dispatch:PropTypes.func,
			saveLaneConditionsInfo: PropTypes.func,
			eventnumberofdays: PropTypes.string,
			dailyoilratios: PropTypes.string,
			oilratio: PropTypes.object,
			isoilratiobygender: PropTypes.string,
			eventgendermen: PropTypes.bool,
			eventgenderwomen: PropTypes.bool,
			maxeventduration:  PropTypes.number,
			startdate:PropTypes.string,
			enddate:PropTypes.string,
			eventId:PropTypes.number,
			dailyoilratiosmen: PropTypes.string,
			dailyoilratioswomen: PropTypes.string,
			eventname: PropTypes.string
    }
    function validate(values) {
        
			const errors = {}

			if (!values.eventname) {
				errors.eventname = 'Required'
			}
			if (!values.startdate) {
				errors.startdate = 'Required'
			}
			if (!values.enddate) {
				errors.enddate = 'Required'
			} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
				errors.email = 'Invalid email address'
			}
			if (!values.sex) {
				errors.sex = 'Required'
			}
			if (!values.favoriteColor) {
				errors.favoriteColor = 'Required'
			}
			return errors
    }
    export default reduxForm({
			validate,
			form:FormName,
			destroyOnUnmount: false,
			forceUnregisterOnUnmount: false
    })(connect(mapStateToProps,mapDispatchToProps)(LaneConditions))



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/LaneConditions/index.js